import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";
import { initTheme } from "./themes/theme";

initTheme();

// Design demos are local-only: production builds drop the chunk entirely. The stage editor ships everywhere.
const DemoApp = import.meta.env.DEV ? lazy(() => import("./demo/DemoApp")) : null;
const StageEditor = lazy(() => import("./demo/stage-editor/StageEditor"));
// The editor lived at /demo/stage first; keep old share links working.
if (/^\/demo\/stage\/?$/.test(window.location.pathname)) history.replaceState(null, "", `/create${window.location.hash}`);
const isStageEditor = /^\/create\/?$/.test(window.location.pathname);
const isDemo = DemoApp !== null && /^\/demo(\/|$)/.test(window.location.pathname);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {isStageEditor ? <Suspense fallback={null}><StageEditor /></Suspense> : isDemo && DemoApp ? <Suspense fallback={null}><DemoApp /></Suspense> : <App />}
  </React.StrictMode>,
);
